/* 🤖 this file was generated by script */
export const wsolidiconFaceHappy = {
  name: 'face_happy',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M9.45 15.6q-.36-.3-.57-.6h6.24q-.21.3-.57.6a4.06 4.06 0 0 1-5.1 0"/><path fill="currentColor" fill-rule="evenodd" d="M1 12a11 11 0 1 1 22 0 11 11 0 0 1-22 0m8-4.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m6 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M7.5 13a1 1 0 0 0-1 1c0 1.22.72 2.36 1.68 3.15a6.06 6.06 0 0 0 7.64 0A4.2 4.2 0 0 0 17.5 14a1 1 0 0 0-1-1z" clip-rule="evenodd"/></svg>`,
  iconStyle: 'solid',
};
